/**
 * Created by Howard on 11/4/2020.
 */

(function($) {
    $('document').ready(function() {
        var singleLodge = $('.single-lodge');
        if (singleLodge.length == 0) {
            // Abandon this script if target does not exist
            return;
        }

        var checkInDate = $('input#check-in-date');
        var checkOutDate = $('input#check-out-date');
        var numGuests = $('select#num-guests');
        var addToCart = $('button[name="add-to-cart"]');

        var postId = parseInt(addToCart.attr('value'));

        if (isNaN(postId)) {
            console.error('WooCommerce add-to-cart button is missing!');
            return;
        }

        //checkInDate.change(getLodgePricing);
        //checkOutDate.change(getLodgePricing);
        //numGuests.change(getLodgePricing);

        numGuests.change(function() {
            $('input[id^="wc_bookings_field_persons"]').val($(this).val());
        });
    });
})(jQuery);